import { render, staticRenderFns } from "./PremiumTextLeftModal.vue?vue&type=template&id=3b8b81ca&scoped=true&"
import script from "./PremiumTextLeftModal.vue?vue&type=script&lang=js&"
export * from "./PremiumTextLeftModal.vue?vue&type=script&lang=js&"
import style0 from "./PremiumTextLeftModal.vue?vue&type=style&index=0&id=3b8b81ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b81ca",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton} from 'bootstrap-vue'
    installComponents(component, {BButton})
    

export default component.exports